module.exports = "pegasus_template/assets/themecapture1/creative/104.png";